import {
  createRoot,
  getOwner,
  Owner as SolidOwner,
  runWithOwner,
} from "solid-js";

import UWeakMap from "@repo/utils/UWeakMap";

namespace UOwner {
  export const makeDetached = () =>
    createRoot((dispose) => Object.assign(getOwner()!, { dispose }));

  const undefinedSymbol = { symbol: "undefined" };
  const onceCache = new WeakMap<
    SolidOwner | typeof undefinedSymbol,
    Set<any>
  >();
  export function runOnce(owner: SolidOwner | null, key: any, fn: () => void) {
    const keyMap = UWeakMap.getOr.lazy(
      onceCache,
      owner || undefinedSymbol,
      () => {
        if (owner)
          (owner.cleanups ||= []).push(() => {
            onceCache.delete(owner);
          });
        return new Set();
      }
    );

    if (keyMap.has(key)) return;
    keyMap.add(key);

    runWithOwner(owner, fn);
  }
}

export default UOwner;
